import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import React from 'react';
import PropTypes from 'prop-types';

function CircularProgressWithLabel({ progess }) {
  // eslint-disable-next-line no-constant-condition
  const value = 0 ? (progess.total === 0) : (progess.now / progess.total) * 100;
  return (
    <Box sx={{
      position: 'absolute',
      top: '30%',
      left: ' 50%',
      bgcolor: 'white',
      p: 2,
      border: 1,
      borderColor: 'primary.main',
      borderRadius: 2,
      boxShadow: 3,
      zIndex: 'tooltip',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <CircularProgress
          variant="determinate"
          value={value}
        />

        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
          >
            {`${Math.round(value)}%`}
          </Typography>
        </Box>

      </Box>
      <Typography color="primary.main" sx={{ ml: 2 }}>
        Завантаження файлів ...
      </Typography>
    </Box>

  );
}

CircularProgressWithLabel.propTypes = {
  progess: PropTypes.shape({
    total: 0,
    now: 0,
  }).isRequired,
};

export default CircularProgressWithLabel;
